export const APP_NAME = 'Cawood Hub'
